/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTransitionRequest
 */
export interface CarveOutTransitionRequest {
    /**
     * 
     */
    reason?: string;
}

/**
 * Check if a given object implements the CarveOutTransitionRequest interface.
 */
export function instanceOfCarveOutTransitionRequest(value: object): value is CarveOutTransitionRequest {
    return true;
}

export function CarveOutTransitionRequestFromJSON(json: any): CarveOutTransitionRequest {
    return CarveOutTransitionRequestFromJSONTyped(json, false);
}

export function CarveOutTransitionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTransitionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function CarveOutTransitionRequestToJSON(json: any): CarveOutTransitionRequest {
    return CarveOutTransitionRequestToJSONTyped(json, false);
}

export function CarveOutTransitionRequestToJSONTyped(value?: CarveOutTransitionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

